<template>
  <div class="w-100 h-100">
    <div
      class="questionnaire-result-content w-100 h-100 d-flex flex-column align-items-center mb-8"
    >
      <div class="mb-7 h-80px h-sm-auto" v-if="imgPath">
        <inline-svg class="h-100" :src="imgPath" />
      </div>
      <div class="d-flex mb-3 step-title fw-boldest text-center">
        {{ header }}
      </div>
      <div class="step-description fw-bold mb-7 text-center">
        {{ description }}
      </div>

      <slot name="content"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionnaireResultWrapper",
  props: {
    header: {
      type: String,
    },
    description: {
      type: String,
    },
    imgPath: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.step-description {
  text-align: center;
}

@media (max-width: 575px) {
  .step-title {
    font-size: 2rem !important;
    line-height: 3rem;
  }

  .step-description {
    font-size: 1.4rem !important;
    line-height: 1.6rem;
    max-width: 85%;
  }
}

@media (min-width: 576px) {
  .step-title {
    font-size: 2.75rem !important;
    line-height: 3.75rem;
  }

  .step-description {
    font-size: 1.25rem !important;
    line-height: 2.5rem;
    max-width: 75%;
  }
}

@media (min-width: 1200px) {
  .step-title {
    font-size: 3.75rem !important;
    line-height: 4.75rem;
  }

  .step-description {
    font-size: 1.85rem !important;
    line-height: 3rem;
    max-width: 75%;
  }
}

@media (min-width: 1400px) {
  .step-description {
    max-width: 57%;
  }
}
</style>
